import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { trackClick } from '../utils/analytics';

const { FiHeart, FiNavigation, FiTrash2, FiMapPin } = FiIcons;

const BookmarksView = ({ bookmarks, onRemove, onNavigate }) => {
  const handleNavigate = (item) => {
    trackClick(`Navigate from Bookmark: ${item.name}`, 'Bookmarks');
    onNavigate(item.lat, item.lng);
  };

  const handleRemove = (item) => {
    trackClick(`Remove Bookmark: ${item.name}`, 'Bookmarks');
    onRemove(item.id);
  };

  if (bookmarks.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-20 px-8 text-center">
        <div className="w-20 h-20 bg-slate-50 rounded-[2.5rem] flex items-center justify-center mb-6">
          <SafeIcon icon={FiHeart} className="text-3xl text-slate-200" />
        </div>
        <h4 className="font-black text-slate-950 text-xl tracking-tight mb-2">No Saved Spots</h4>
        <p className="text-slate-400 text-xs font-medium leading-relaxed max-w-[200px]">
          Tap the heart icon on any result to save it here for quick access.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-6 px-2">
      <div className="flex items-center justify-between">
        <h3 className="text-xl font-black text-slate-950 tracking-tighter">
          My <span className="text-indigo-600">Bookmarks</span>
        </h3>
        <span className="text-[9px] font-black text-slate-400 uppercase tracking-widest bg-slate-50 px-3 py-1 rounded-full">
          {bookmarks.length} Saved
        </span>
      </div>

      <div className="space-y-4">
        <AnimatePresence mode="popLayout">
          {bookmarks.map((item) => (
            <motion.div 
              key={item.id} 
              layout
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: 20 }}
              className="bg-white p-6 rounded-[2rem] border border-slate-100 high-contrast-shadow flex items-center gap-4 group"
            >
              <div className="w-12 h-12 bg-indigo-50 rounded-2xl flex items-center justify-center flex-shrink-0 text-indigo-600 transition-colors group-hover:bg-indigo-600 group-hover:text-white">
                <SafeIcon icon={FiMapPin} />
              </div>
              <div className="flex-1 min-w-0">
                <h5 className="font-black text-slate-950 text-sm truncate tracking-tight mb-0.5">
                  <span className="bg-indigo-50 px-1 rounded transition-colors group-hover:bg-indigo-100">
                    {item.name}
                  </span>
                </h5>
                <p className="text-[9px] font-bold text-slate-400 uppercase tracking-widest truncate">{item.category}</p>
              </div>
              <div className="flex gap-2">
                <button 
                  onClick={() => handleNavigate(item)}
                  className="p-3 bg-slate-950 text-white rounded-xl hover:bg-black transition-colors"
                >
                  <SafeIcon icon={FiNavigation} className="text-sm" />
                </button>
                <button 
                  onClick={() => handleRemove(item)}
                  className="p-3 bg-rose-50 text-rose-600 rounded-xl hover:bg-rose-100 transition-colors"
                >
                  <SafeIcon icon={FiTrash2} className="text-sm" />
                </button>
              </div>
            </motion.div>
          ))}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default BookmarksView;